import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { defineMessages, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { LoyaltyMyReservations } from "@witbooking/react-components";
import { getTranslatedCountryList } from "../../intl/intUtils";
import { useSelector } from "react-redux";
import { loyaltySelector } from "../App/selectors";
import GlobalLoader from "../../components/GlobalLoader";
import { Redirect, useParams } from "react-router";
import constants from "../../utils/constants";
import styled from "styled-components";
import LOCAL_STORAGE_KEYS from "../../utils/constants";
import { parse } from "date-fns";

const LinkStyled = styled(Link)`
  text-decoration: underline;
  color: #ababb0;
  cursor: pointer;
`;

const messages = defineMessages({
  manage: {
    id: "loyalty.transactionsList.manage",
    description: "Transactions list field: manage",
    defaultMessage: "Gestionar",
  },
});

export default function MyReservations({ handleModalContent, handleCloseModal, loyaltyUser }) {
  const intl = useIntl();
  const countries = useMemo(() => getTranslatedCountryList(intl.locale), [intl]);
  const [isLoading, setIsLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [customerProfile, setCustomerProfile] = useState({});
  const params = useParams();

  // Selectors
  const loyalty = useSelector(loyaltySelector);

  const tier = useMemo(() => {
    const { ticker, benefitDescription } = loyalty || {};
    let numberOfReservations = 0;
    transactions.forEach(element => {
      if (element.status !== "CANCELLED") {
        numberOfReservations++;
      }
    });
    return {
      benefits: benefitDescription,
      category: ticker,
      numberOfReservations,
    };
  }, [loyalty, transactions]);

  const getTransactions = useCallback(async () => {
    if (!loyaltyUser) {
      return;
    }
    const url = `${window.__additionalData.API_LOYALTY_URL}/v1/${loyaltyUser.brandTicker}/transactions`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${loyaltyUser.jwt}`,
        },
      });
      if (response.status === 200) {
        const { data } = response;
        const transactions = data.map(
          ({ amount, transactionData, createdAt, description, status }) => {
            const {
              propertyName,
              propertyTicker,
              reservationId,
              checkin,
              checkout,
              numGuests,
            } = transactionData;
            return {
              status,
              amount,
              propertyName,
              propertyTicker,
              reservationId,
              createdAt,
              checkin,
              checkout,
              numGuests,
              descriptionRoom: description,
              link:
                status === "CANCELLED" ? null : (
                  <LinkStyled
                    to={`/${propertyTicker}/${intl.locale}/${constants.STEP_PATHS.STEP_3}/${reservationId}`}
                    target="_blank">
                    <FormattedMessage {...messages.manage} />
                  </LinkStyled>
                ),
            };
          }
        );
        setTransactions(transactions);
      }
    } catch (error) {
      console.error(error);
    }
  }, [loyaltyUser, intl, window.__additionalData.API_LOYALTY_URL]);

  useEffect(() => {
    async function fetch() {
      await Promise.all([getTransactions()]);
      setIsLoading(false);
    }

    fetch();
  }, [getTransactions]);

  if (!loyaltyUser) {
    return <Redirect to={`/${params.hotelTicker}/${constants.STEP_PATHS.STEP_1}`} />;
  }

  if (isLoading) {
    return <GlobalLoader />;
  }

  return (
    <LoyaltyMyReservations
      showArrow={true}
      transactions={transactions}
      tier={tier}
      myAccountClicked={true}
      myReservationsClicked={true}
    />
  );
}
